// extracted by mini-css-extract-plugin
module.exports = {"backdrop":"Modal_backdrop__Fia1o","modal":"Modal_modal__pGQ8c","slide-down":"Modal_slide-down__BMw5A"};